import { useState, useMemo } from "react";
import { useCancelAnswer, useQnaQuestions } from "../../api/qnaApi";
import { useStaff } from "../../api/staffApi";
import Table from "../../components/Table";
import {
  QnaQuestionTableDef,
  QnaStaffTableDef,
} from "../../table/QnaQuestionTableDef";
import { useFilter, SingleFilter } from "../../components/Filter";
import { getQnaFilterDict } from "../../filters/qnaFilter";
import { usePagination } from "../../components/Pagination";

const StaffForum = () => {
  const [filters, setFilters] = useState({});
  const { pagination, setPage } = usePagination();
  const { mutateAsync: cancelAnswer } = useCancelAnswer();

  const { data: staff, isLoading: isStaffLoading } = useStaff();
  const { data: questions, isLoading: isQuestionsLoading } = useQnaQuestions({
    filters,
    pagination,
  });
  const { valueDict, setValue, deleteKeyword } = useFilter();

  const handleCancel = async (questionId: number) => {
    try {
      await cancelAnswer({ id: questionId });
      alert("답변이 취소되었습니다.");
    } catch (e) {
      alert("답변 취소에 실패했습니다.");
    }
  };

  const maxPage = useMemo(() => {
    if (!questions) return 0;
    return Math.ceil(questions.total / 10);
  }, [questions]);

  if (isStaffLoading) return <p>로딩 중...</p>;

  return (
    <div className="wideContent">
      <div className="search">
        <SingleFilter
          valueDict={valueDict}
          filterDict={getQnaFilterDict(staff.staff.department, "staff")}
          setValue={setValue}
          deleteKeyword={deleteKeyword}
        />
        <button
          onClick={() => {
            setPage(0);
            setFilters(valueDict);
          }}
        >
          검색
        </button>
      </div>
      {isQuestionsLoading ? (
        <p>로딩 중...</p>
      ) : questions.questions.length ? (
        <Table
          columns={[...QnaQuestionTableDef, ...QnaStaffTableDef(handleCancel)]}
          data={questions.questions}
          rowLink={(original) => `${original.id}${window.location.search}`}
          paginationProps={{ page: pagination.page, setPage, maxPage }}
          columnPinning={{}}
        />
      ) : (
        <p>등록된 글이 없습니다.</p>
      )}
    </div>
  );
};

export default StaffForum;
